import React from 'react';

import { Box, Fade } from '@mui/material';
import { useIsMobile } from '@uplift/hooks';
import { CalendarStoreProvider } from '@uplift/providers';
import { CalendarStore } from '@uplift/store';

import { CalendarDesktop, CalendarMobile } from '../components/provider-calendar';
import { TutorialBanner } from './tutorial-banner.componnet';

export const CalendarContent: React.FC = () => {
  const calendarStore = React.useMemo(() => new CalendarStore(), []);
  const isMobile = useIsMobile();

  return (
    <CalendarStoreProvider calendarStore={calendarStore}>
      <TutorialBanner />
      <Fade in>
        <Box display="flex" flex={1} width="100%" height="100%">
          {isMobile ? (
            <CalendarMobile />
          ) : (
            <CalendarDesktop />
          )}
        </Box>
      </Fade>
    </CalendarStoreProvider>
  );
};
